import dvaModelExtend from 'dva-model-extend';
import _ from 'lodash';

import { bindServices } from '@/services/api';
import { toPaginate } from '@/utils/infrastructure';
import { createCrudModel } from '@/utils/core/dva';
import CoreQueries from '@/utils/input/queries';

import { ENTITY_NAME, FETCH_ROUTE, MODEL_NAME } from './constants';

const api = bindServices(MODEL_NAME);
const fetchParams = 'UserDevice';

function applyDeviceLockedState(item, locked) {
  const next = { ...item };
  if (locked) {
    next.locked = true;
  } else {
    delete next.locked;
  }
  return next;
}

const _model = createCrudModel({
  namespace: MODEL_NAME,
  fetchRoute: FETCH_ROUTE,
  fetchParams,
  entityName: ENTITY_NAME,
  api,
  features: { import: false, bulkActions: true },
  effects: {
    *fetchList({ payload }, { call, put, select }) {
      try {
        const pageSize = yield select((state) => state.global.pageSize);
        const params = { ...CoreQueries[fetchParams].paged, pageSize, ...payload };
        const res = yield call(api.getAll, {
          route: `${FETCH_ROUTE}/paged`,
          params,
          readPriority: true,
        });
        const items = res?.items || res?.data || [];
        const page = payload.page ?? 1;
        const limit = payload.limit ?? pageSize;
        const totalCount = res?.totalCount ?? res?.count ?? res?.total ?? items.length;
        yield put({ type: 'queryData', payload: { ...res, limit, page, totalCount, items } });
      } catch (e) {
        /*  */
      }
    },

    *fetchItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'success', payload: false });
        const res = yield call(api.getById, {
          route: FETCH_ROUTE,
          id: payload.id,
          params: CoreQueries[fetchParams].itemDetail,
        });
        const item = Array.isArray(res) ? res[0] : res;
        yield put({ type: 'queryItem', payload: item });
      } catch (e) {
        /*  */
      }
    },

    *fetchDelete({ payload }, { call, put }) {
      try {
        const { id, view } = payload;
        yield put({
          type: 'global/modalConfirm',
          payload: { state: false, id: null, modelDelete: null },
        });
        if (view) {
          yield put({
            type: 'queryShowForm',
            payload: { state: false, item: null, detail: false, id: null },
          });
        }
        yield call(api.remove, { route: FETCH_ROUTE, id });
        yield put({ type: 'success', payload: { success: true } });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: { visible: true, type: 'error', message: error.message },
          });
        }
      }
    },

    *setDeviceLocked({ payload }, { call, put }) {
      try {
        const { id, locked } = payload;
        yield call(api.exec, {
          route: `${FETCH_ROUTE}/lockUnlock/${id}/${locked}`,
          httpMethod: 'post',
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'applyDeviceLocked', payload: { id, locked } });
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: { visible: true, type: 'error', message: error.message },
          });
        }
      }
    },
  },
  reducers: {
    applyDeviceLocked(state, { payload }) {
      const { id, locked } = payload;
      const patchItem = (item) => (item?.id === id ? applyDeviceLockedState(item, locked) : item);

      return {
        ...state,
        list: (state.list || []).map(patchItem),
        item: patchItem(state.item),
      };
    },
    queryData(state, { payload }) {
      const items = payload.items ?? payload.data ?? state.list;
      return {
        ...state,
        list: items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
  },
});

export default dvaModelExtend(_model, { namespace: MODEL_NAME });
